<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #search>
        <ExpansionPanel :isUpDown="false">
          <template #header>
            <div class="searchAreaStyle d-flex align-center mr-5">
              <span class="titleStyle font-weight-bold pl-10">
                {{ $t('storage.storage_storage-move-reason') }}
              </span>
            </div>
            <v-checkbox
              v-model="filter.isEnabled"
              :label="
                $t('common.common_hide-unused-storage-move-reason-method')
              "
            />
          </template>
        </ExpansionPanel>
      </template>
      <template #button>
        <NormalButton
          :text="buttonName"
          height="32px"
          width="140px"
          class="text-right"
          @click="dialogInfo.register = true"
        />
        <MasterStockMoveReasonDialog
          v-model="dialogInfo.register"
          @success="registerSuccess()"
        />
      </template>
      <template #list>
        <div class="stockMoveReasonTable">
          <v-data-table
            :headers="tableHeaders"
            :items="getFilterStockMoveReasonList"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #[`item.isEnabled`]="{ item }">
              {{ getStockMoveReasonStatus(item.isEnabled) }}
            </template>
            <template #[`item.name`]="{ item }">
              <div class="font-weight-bold">{{ item.name || '-' }}</div>
            </template>
            <template #[`item.sortNumber`]="{ item }">
              <div class="text-center">
                {{ item.sortNumber || '-' }}
              </div>
            </template>
            <template #[`item.edit`]="{ item }">
              <v-layout>
                <WhiteButton
                  text="common.common_edit"
                  height="32px"
                  width="48px"
                  class="mx-2"
                  @click="edit(item)"
                />
                <div v-if="item.isEnabled" class="mx-auto">
                  <NormalButton
                    :text="$t('表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    @click="editIsEnabledToFalse(item)"
                  />
                </div>
                <div v-else class="mx-auto">
                  <NormalButton
                    :text="$t('非表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    color="white"
                    textColor="thinText--text"
                    @click="editIsEnabledToTrue(item)"
                  />
                </div>
              </v-layout>
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <MasterStockMoveReasonDialog
      v-model="dialogInfo.edit"
      :stockMoveReasonData="stockMoveReasonData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import headers from './headers'
import { Master } from '@/components/layouts'
import { MasterStockMoveReasonDialog } from '@/components/layouts/Dialogs'
import { ExpansionPanel, NormalButton, WhiteButton } from '@/components/items'
export default {
  components: {
    ExpansionPanel,
    Master,
    MasterStockMoveReasonDialog,
    NormalButton,
    WhiteButton
  },
  data: () => {
    return {
      pageTitle: 'storage.storage_storage-move-reason-manage',
      buttonName: 'storage.storage_storage-move-reasont-register',
      stockMoveReasonData: {},
      dialogInfo: {
        register: false,
        edit: false
      },
      headers: headers.headers,
      itemKey: 'stockMoveReasonId',
      editMode: false,
      filter: {
        isEnabled: true
      }
    }
  },
  created() {
    this.init()
  },
  computed: {
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    },
    getFilterStockMoveReasonList() {
      let stockMoveReasonList = this.getStockMoveReasonListFromState()
      // 非表示フラグ
      const isEnabledFlg = this.filter.isEnabled
      if (isEnabledFlg) {
        stockMoveReasonList = stockMoveReasonList.filter((stockMoveReason) => {
          return stockMoveReason.isEnabled === 1
        })
      }
      return stockMoveReasonList
    }
  },
  methods: {
    ...mapActions('StockMove', [
      'getStockMoveReasonListFromApi',
      'editStockMoveReason'
    ]),
    ...mapGetters('StockMove', ['getStockMoveReasonListFromState']),
    async init() {
      await this.getStockMoveReasonListFromApi()
    },
    getStockMoveReasonStatus(isEnabled) {
      const stockMoveReasonStatus = isEnabled
        ? this.$t('common.common_normal')
        : this.$t('common.common_hide')
      return stockMoveReasonStatus
    },
    edit(stockMoveReason) {
      this.stockMoveReasonData = { ...stockMoveReason }
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async editIsEnabledToFalse(item) {
      await this.editStockMoveReason({
        id: item.stockMoveReasonId,
        name: item.name,
        sortNumber: item.sortNumber,
        isEnabled: false
      })
      item.isEnabled = 0
    },
    async editIsEnabledToTrue(item) {
      await this.editStockMoveReason({
        id: item.stockMoveReasonId,
        name: item.name,
        sortNumber: item.sortNumber,
        isEnabled: true
      })
      item.isEnabled = 1
    }
  }
}
</script>
<style scoped lang="scss">
.stockMoveReasonTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
}
.search {
  background-color: #fff;
}
.searchAreaStyle {
  height: 70px;
  .titleStyle {
    font-size: 18px;
  }
}
</style>
